import { useEffect, useState } from 'react'

export function WindowsDownloadLink() {
  const [url, setUrl] = useState<string>()
  const [unavailable, setUnavailable] = useState(false)

  useEffect(() => {
    const controller = new AbortController()
    fetch('/windows/latest.json', { cache: 'no-store', credentials: 'omit', signal: controller.signal })
      .then(async response => {
        if (!response.ok) throw new Error('download_unavailable')
        const release = await response.json()
        if (release.channel !== 'direct' || release.architecture !== 'x64' ||
          !/^https:\/\/spectraguardai\.com\/windows\/SpectraGuardAI-\d+\.\d+\.\d+-[1-9]\d*-x64-Setup\.exe$/.test(release.url)) {
          throw new Error('download_unavailable')
        }
        setUrl(release.url)
      })
      .catch(() => { if (!controller.signal.aborted) setUnavailable(true) })
    return () => controller.abort()
  }, [])

  return <a href={url} aria-disabled={!url} onClick={event => { if (!url) event.preventDefault() }}>
    {url ? '↓ Baixar para Windows' : unavailable ? 'Windows · download indisponível' : 'Windows · carregando…'}
  </a>
}
